import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ShareIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.471 18.3516L17.4792 7.82293C17.7001 7.04971 16.9643 6.34523 16.2014 6.59953L5.84605 10.0513C4.93435 10.3552 4.93436 11.6448 5.84605 11.9487L8.94454 12.9815C9.24858 13.0829 9.58278 13.0323 9.84328 12.8456L12.0082 11.2941C12.468 10.9646 13.0354 11.532 12.7059 11.9918L11.1907 14.106C10.9841 14.3943 10.9456 14.7705 11.0897 15.0947L12.5956 18.483C12.9751 19.3369 14.2143 19.2501 14.471 18.3516Z"
        fill={fillColor || '#48484B'}
      />
    </svg>
  );
};

export { ShareIcon };
